import request from '@/utils/request'
import { Message } from 'element-ui';

function Pagination(page, size) { // 分页参数
    this.page = page;
    this.pagesize = size;
    this.pageorder = 'string';
    this.pagesort = 'string'
}
function getPath(folders) {
    let path = '/'
    folders.forEach((folder) => {
        if (folder.path) {
            path += `${folder.path}/`
        }
    })
    return path
}

function getPaths(folders, multiSelection, withNum) {
    let paths = []
    let path

    let f = folders
    if (multiSelection && multiSelection.selectAll) {
        if (folders.length == 1) {
            if (withNum) {
                paths.push({
                    path: '/',
                    num: multiSelection.total
                })
            } else {
                paths.push({
                    path: '/',
                })
            }
        } else {
            // f = folders.slice(0, folders.length - 1)
            path = getPath(f)
            if (withNum) {
                paths.push({
                    bid: f[f.length - 1].bid,
                    path: path,
                    num: multiSelection.total
                })
            } else {
                paths.push({
                    bid: f[f.length - 1].bid,
                    path: path
                })
            }
        }
    } else {
        path = getPath(folders)
        multiSelection.selection.forEach((select) => {
            // console.log(select)
            let cPath = path
            if (select.path) {
                cPath += `${select.path}/`
            }
            if (withNum) {
                paths.push({
                    bid: select.bid,
                    path: cPath,
                    num: select.cnt || 1
                })
            } else {
                paths.push({
                    bid: select.bid,
                    path: cPath,
                })
            }
            if (select.id) {
                paths[paths.length - 1].lid = select.id
            }
        })
    }
    return paths
}
// 获取项目列表
export function getProjectList(pid, tid, page, size) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/project/list',
        method: 'post',
        data: {
            projectId: pid, // 任务流ID
            validateTaskId: tid, // 项目ID
            ...new Pagination(page, size)
        }
    })
}

// 各状态文件数
export function getStateNum(pid) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/stat',
        method: 'post',
        params: {
            projectId: pid // 任务流ID
        }
    })
}

// 获取文件(夹)列表
export function getFolderList(pid, status, bid, path, stime, etime, page, size, check_uid, quality_uid,selectNotes, is_validate, vc_times, searchpath) {
    let reqData = {
        ...new Pagination(page, size),
        projectId: pid,
        status: status, // 文件当前状态
        path: path, // 当前路径
        stime: stime, // 起始时间
        etime: etime, // 终止时间
        check_uid : check_uid,
        quality_uid : quality_uid,
        is_validate: is_validate,
        vc_times: vc_times // 被验收次数
    }
    if (bid) { // 批次ID(已弃用)
        reqData['bid'] = bid
    }
    if(selectNotes){//是否有批注
        reqData.selectNotes = selectNotes
    }
    if(searchpath) {
      reqData.searchpath = searchpath
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/list',
        method: 'post',
        data: reqData
    })
}
// 获取文件总数
export function getFileNum(pid, status, bid, path, stime, etime, is_validate, vc_times, searchpath) {
    let reqData = {
        projectId: pid, // 任务流id
        status: status, // 文件当前状态
        path: path, // 当前路径
        stime: stime, // 起始时间
        etime: etime, // 终止时间
        is_validate: is_validate, // 打回重做
        vc_times: vc_times // 被验收次数
    }
    if (bid) {
        reqData['bid'] = bid
    }
    if(searchpath) {
      reqData['searchpath'] = searchpath
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/totalnum',
        method: 'post',
        data: reqData
    })
}

// 生成抽检文件
export function createSampling(num, rate, folders, multiSelection, stime, etime, quality_uid, total, is_validate, has_note, remark,check_type,check_tag) {
    let paths = getPaths(folders, multiSelection, true)
    let reqData = {
        num: num, // 文件数量
        rate: rate, // 抽检率
        paths: paths, // 每个文件的信息及路径 详见getPaths方法
        pid: folders[0].id, // 任务流ID
        // total: multiSelection.total, // 选择总数
        total,
        check_type:check_type,
        check_tag:check_tag,
        stime: stime,
        etime: etime,
        quality_uid: quality_uid,
        is_validate: is_validate,
        remark: remark,
        has_note
    }
    return request({
        // url: '/v1/api/safe/annotate/validate/tags/spotcheck/save',
        // url: '/v1/api/safe/annotate/validate/tags/spotcheck/createnewtask',
        url: '/v1/api/safe/annotate/validate/tags/spotcheck/createspotchecktask',
        method: 'post',
        data: reqData
    })
}

// 抽检文件夹列表
export function getSamplingList(pid, type, status, page, size, taskId, stime, etime, vc_times) {
    let reqData = {
        projectId: pid,
        type: type, // 类型
        status: status, // 抽检状态
        id: taskId, // 抽检任务id
        stime: stime,
        etime: etime,
        vc_times: vc_times, // 验收次数
        ...new Pagination(page, size)
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/spotcheck/list',
        method: 'post',
        data: reqData
    })
}

// 获取抽检文件数目
export function getSamplingNum(pid, type, stime, etime, is_validate, vc_times) {
    let reqData = {
        projectId: pid,
        type: type, //类型
        stime: stime,
        etime: etime,
        is_validate: is_validate, // 打回重做
        vc_times: vc_times // 被验收次数
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/spotcheck/totalnum',
        method: 'post',
        data: reqData
    })
}

// 抽检任务文件列表
export function getSamplingFile(pid, spotid, type, status, statusSet, page, size, stime, etime,selectNotes, quality_uid, is_validate, vc_times) {
    let reqData = {
        projectId: pid, // 任务流ID
        type: type, // 抽检任务类型: 1-抽检中, 3-抽检失败
        id: spotid, // 抽检文件ID
        status: status, // 类型
        stime: stime,
        etime: etime,
        quality_uid: quality_uid,
        is_validate: is_validate, // 打回重做
        vc_times: vc_times, // 验收次数
        ...new Pagination(page, size)
    }
    if (statusSet) { // 筛选状态条件
        reqData.statusSet = statusSet
    }
    if(selectNotes){//是否有批注
        reqData.selectNotes = selectNotes
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/spotcheckdb/list',
        method: 'post',
        data: reqData
    })
}

// 验收通过、失败
export function validateOperation(currentStatus, status, folders, multiSelection, reason, stime, etime, quality_uid) {
    let paths = getPaths(folders, multiSelection, false)
    let reqData = {
        currentStatus: currentStatus, // 当前状态
        status: status, // 3-成功, 4-失败
        paths: paths, // 每个文件的路径及信息
        pid: folders[0].id, // 任务流ID
        reason: reason, // 失败原因
        stime: stime,
        etime: etime,
      quality_uid: quality_uid
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libsdb/status',
        method: 'post',
        data: reqData
    })
}

// 抽检通过失败,取消抽检
export function samplingOpeation(id, pid, type, currentType,reason) {

    let reqData = {
        id: id,
        pid: pid,
        type: type, // 2-通过 3-失败 4-取消
        currentType: currentType
    }
    if(type == 3){
      reqData.reason = reason
    }
    return request({
        // url: '/v1/api/safe/annotate/validate/tags/spotcheck/spotstatus',
        url: '/v1/api/safe/annotate/validate/tags/spotcheck/operatestatus',
        method: 'post',
        data: reqData
    })
}

// 获取流程图
export function getProgress(id) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/modules/list',
        method: 'post',
        data: {
            projectId: id // 任务流ID
        }
    })
}

// 获取验收文件详情
export function getFileDetails(lid, pid) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libsdb/detail',
        method: 'post',
        params: {
            lid: lid ,// 文件ID，
            pid: pid, // 任务流ID
        }
    })
}

// 获取抽检文件详情
export function getSpotDetails(lid, pid, taskId) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/spotcheck/detail',
        method: 'post',
        params: {
            lid: lid, // 文件ID
            pid: pid, // 任务流ID
            taskid: taskId // 抽检任务ID
        }
    })
}

// 获取导出 Json 配置文件
export function getFormatJson(id) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/project/formatjson',
        method: 'post',
        params: {
            id: id // 任务流ID
        }
    })
}

// 更新导出 Json 配置文件
export function updateFormatJson(id, jsonString) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/project/formatjson/update',
        method: 'post',
        data: {
            id: id, // 任务流ID
            jsonString: jsonString // 配置文件 string
        }
    })
}

// 获取一个（龙猫）标准的导出 Json
export function getFormJson(id) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/project/formatjson',
        method: 'post',
        params: {
            id: id // 任务流ID
        }
    })
}
//导出csv
export function getCsv(folders,multiSelection,params){
    let paths = getPaths(folders, multiSelection, false);
    let obj = {}
    paths.forEach(item=>{
        if(item.lid){
            if(!obj.ids){
                obj.ids=[]
            }
            obj.ids.push(item.lid)
        }else if(item.path){
            if(!obj.paths){
                obj.paths=[]
            }
            obj.paths.push(item.path)
        }
    })
    obj.paths && (obj.paths = JSON.stringify(obj.paths))
    obj.ids && (obj.ids = JSON.stringify(obj.ids))
    console.log(obj)
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/export',
        method: 'post',
        data: {
            ...params,
            ...obj
        }
    })
}
//去重导出csv
export function getRepeatCsv(folders,multiSelection,params){
    let paths = getPaths(folders, multiSelection, false);
    let obj = {}
    paths.forEach(item=>{
        if(item.lid){
            if(!obj.ids){
                obj.ids=[]
            }
            obj.ids.push(item.lid)
        }else if(item.path){
            if(!obj.paths){
                obj.paths=[]
            }
            obj.paths.push(item.path)
        }
    })
    obj.paths && (obj.paths = JSON.stringify(obj.paths))
    obj.ids && (obj.ids = JSON.stringify(obj.ids))
    console.log(obj)
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/repeat/export',
        method: 'post',
        data: {
            ...params,
            ...obj
        }
    })
}
//导出csv
export function createCsv(folders,multiSelection,params){
    let paths = getPaths(folders, multiSelection, false);
    let obj = {}
    paths.forEach(item=>{
        if(item.lid){
            if(!obj.ids){
                obj.ids=[]
            }
            obj.ids.push(item.lid)
        }else if(item.path){
            if(!obj.paths){
                obj.paths=[]
            }
            obj.paths.push(item.path)
        }
    })
    obj.paths && (obj.paths = JSON.stringify(obj.paths))
    obj.ids && (obj.ids = JSON.stringify(obj.ids))
    console.log(obj)
    return request({
        url: '/v1/api/safe/annotate/validate/tags/export/create',
        method: 'post',
        data: {
            ...params,
            ...obj
        }
    })
}


export function getExcel(pid,id){
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/downlog',
        method: 'post',
        data: {
            projectId:pid,
            id:id
        }
    })
}


//获取下载文件历史记录
export function getDownloadHistory(pid) {
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libs/exportlog',
        method: 'post',
        data: {
            projectId:pid
        }
    })
}
// 获取历史记录详情
export function getHistoryDetail(id){
  return request({
      url: '/v1/api/safe/annotate/validate/tags/libs/exportlogdetail',
      method: 'post',
      data: {
        id: id // 历史记录ID
      }
  })
}




//getOssToken
export function getOssToken() {
    return request({
        url: '/v1/api/safe/annotate/validate/oss/token',
        method: 'post',
    })
}

//获取“数据总览”总数据
export function getDataSumStat(pid) {
    return request({
        url: 'v1/api/safe/annotate/validate/tags/libs/datascreening',
        method: 'post',
        data: {
            pid:pid
        }
    })
}


//获取“数据总览”各分项数据
export function getDataSumPartData(projectId,status) {
    return request({
        url: 'v1/api/safe/annotate/validate/tags/libs/screeninginfo',
        method: 'post',
        params: {
            projectId:projectId,
            status:status
        }
    })
}

export function getProjectAuth(projectId) {
  return request({
      url: '/v1/api/safe/annotate/validate/project/auth?vid=' + projectId,
      method: 'post'
  })
}

export function getSpotHistory(projectId) {
  return request({
      url: '/v1/api/safe/annotate/validate/tags/spotcheck/history?pid=' + projectId,
      method: 'post'
  })
}
export function getSpotHistoryDetail(id) {
  return request({
      url: '/v1/api/safe/annotate/validate/tags/spotcheck/wrong?id=' + id,
      method: 'post'
  })
}

export function getCheckLogHistory(projectId) {
  return request({
    url: '/v1/api/safe/annotate/validate/tags/libs/export/check?id=' + projectId,
    method: 'post'
  })
}

export function retrySubTask(id) {
  return request({
    url: '/v1/api/safe/annotate/validate/tags/export/retry?id=' + id,
      method: 'post'
  })
}

export function getLibsdbSearch(pid, status, type, name, page, size) {
    let reqData = {
        ...new Pagination(page, size),
        pid: pid,
        project_id: pid,
        status: status, // 文件当前状态
        name: name, // 文件名
        type // 搜索的类型
    }
    return request({
        url: '/v1/api/safe/annotate/validate/tags/libsdb/search',
        method: 'post',
        data: reqData
    })
}

// 上传文件授权
export function getUploadSign(data) {
  return request({
    url: '/v1/api/safe/common/sdk/upload/sign',
    method: 'post',
    data
  })
}

// 修改抽检别名
export function setSpotCheckName(data) {
  return request({
    url: '/v1/api/safe/annotate/validate/tags/spotcheck/modify',
    method: 'post',
    data
  })
}


// 修改抽检别名
export function updateDesc(data) {
    return request({
      url: '/v1/api/safe/annotate/validate/tags/libs/desc/insert',
      method: 'post',
      data
    })
  }

  //jar包列表
export function getJarHistory(pid){
    return request({
        url: '/v1/api/safe/annotate/impexp/script/list',
        method: 'post',
        params: {
          pid: pid,
          type: 2
        }
    })
  }

//jar包弹窗--导出配置新增和修改接口
export function outSettings(data){
    return request({
        url: '/v1/api/safe/annotate/impexp/script/save',
        method: 'post',
        params: data
    })
}

export function getExportList(projectId, page) {
    if (!page) {
        page = 1
    }
  return request({
      url: '/v1/api/safe/annotate/impexp/exp/job/task/list',
      method: 'post',
      data : {
        fid: projectId,
        page: page
      },
      transformRequest: [
        function (data) {
          return stringify(data)
        }
      ],
  })
}

export function getExportSubList(id, page) {
    if (!page) {
        page = 1
    }
  return request({
      url: '/v1/api/safe/annotate/impexp/exp/job/data/list',
      method: 'post',
      params: {
        tid: id,
        page: page
      }
  })
}

export function cloudExport(folders, multiSelection, data) {
    let paths = getPaths(folders, multiSelection, false);
    let obj = {}
    paths.forEach(item=>{
        if(item.lid){
            if(!obj.ids){
                obj.ids=[]
            }
            obj.ids.push(item.lid)
        }else if(item.path){
            if(!obj.paths){
                obj.paths=[]
            }
            obj.paths.push(item.path)
        }
    })
    obj.paths && (obj.paths = JSON.stringify(obj.paths))
    obj.ids && (obj.ids = JSON.stringify(obj.ids))
    console.log(obj)
    return request({
        url: '/v1/api/safe/annotate/impexp/exp/job/task/save',
        method: 'post',
        data: {
            ...data,
            ...obj
        }
      })
}

export function queryExportLog(id) {
    return request({
        url: '/v1/api/safe/annotate/impexp/exp/job/task/logs',
        method: 'post',
        data: {id : id}
      })
}

function stringify (data) {
  const formData = new FormData()
  for (const key in data) {
    // eslint-disable-next-line no-prototype-builtins
    if (data.hasOwnProperty(key)) {
      if (data[key]) {
        if (data[key].constructor === Array) {
          if (data[key][0]) {
            if (data[key][0].constructor === Object) {
              formData.append(key, JSON.stringify(data[key]))
            } else {
              data[key].forEach((item, index) => {
                formData.append(key + `[${index}]`, item)
              })
            }
          } else {
            formData.append(key + '[]', '')
          }
        } else if (data[key].constructor === Object) {
          formData.append(key, JSON.stringify(data[key]))
        } else {
          formData.append(key, data[key])
        }
      } else {
        if (data[key] === 0) {
          formData.append(key, 0)
        } else {
          formData.append(key, '')
        }
      }
    }
  }
  return formData
}

// 查询数据集列表
export function getDatasetList() {
  return request({
    url: '/v1/api/safe/common/dataset/homepage/list',
    method: 'post',
    data: {
      status: 1
    }
  })
}

// 查询数据集内的文件夹列表
export function getDatasetFolderList({ uid, setId, rePath }) {
  return request({
    url: '/v1/api/safe/common/dataset/storage/datalist',
    method: 'post',
    data: {
      current: 1,
      head: 1,
      searchPath: 2,
      size:1000,
      status:1,
      rePath,
      setId,
      uid
    }
  })
}



/*
查询数据集导出列表
fid 任务流ID
*/
export function getExportDatasetList({fid, page, pagesize }) {
  return request({
    url: `/v1/api/safe/annotate/impexp/exp/job/dataset/list?fid=${fid}&page=${page}&pagesize=${pagesize}`,
    method: 'post',
    // data: { fid }
  })
}

/*
导出到数据集
tid   导出ID
fid   任务流ID
dataset_id   数据集ID
dataset_path   数据集路径
*/
export function exportDataset({ tid, fid, dataset_id, dataset_path, dataset_name }) {
  return request({
    url: `/v1/api/safe/annotate/impexp/exp/job/dataset/save`,
    method: 'post',
    params: {
      tid,
      fid,
      dataset_id,
      dataset_path,
      dataset_name
    }
  })
}

/*
导出到数据集列表详情
did   导出到数据集的记录记录ID
*/
export function getExportDatasetDetail({did, page, pagesize}) {
  return request({
    url: '/v1/api/safe/annotate/impexp/exp/job/dataset/sub/list',
    method: 'post',
    params: {
      did,
      page,
      pagesize
    }
  })
}

/**
 *
 * 修改抽检比例
 *
 */
export function updateSpotRate(pid, spot_task_id, ratio, change_nums) {
    return request({
      url: '/v1/api/safe/annotate/validate/tags/spotcheck/replanratio',
      method: 'post',
      data: {
        pid: pid,
        spot_task_id: spot_task_id,
        ratio :ratio,
        change_nums: Math.abs(change_nums)
      }
    })
  }

  export function updateFrameSpotRate(spot_task_id, ratio) {
    return request({
      url: '/v1/api/safe/annotate/validate/tags/spotcheck/frame_check_rate',
      method: 'post',
      data: {
        spot_task_id: spot_task_id,
        ratio :ratio
      }
    })
  }

  // 导出抽检数据
  export function exportSpotCheck(folders, multiSelection, name) {
    let taskIds
    let taskId
    let ids
    const selection = multiSelection.selection
    const projectId = folders[0].id
    if(folders.length <= 1) {
      // 选择抽检任务文件夹
      taskIds = JSON.stringify(selection.map(item => item.id))
    } else {
      // 选择抽检中的数据
      taskId = String(folders[1].id)
      ids = JSON.stringify(selection.map(item => item.id))
    }

    return request({
      url: '/v1/api/safe/annotate/validate/tags/libs/export/spotcheck',
      method: 'post',
      data: {
        taskId, // 抽检任务id(一个抽检任务选择多个数据)
        ids, // 数据id
        taskIds, // 抽检任务id(选择多个抽检任务)
        projectId, // 任务流id
        name, // 导出的文件名
      }
    })
  }

  // 获取任务流配置信息
  export function getWorkflowConfig(pid) {
    return request({
      url: `/v1/api/safe/annotate/validate/tags/libsdb/options?pid=${pid}`,
      method: 'post'
    })
  }

  // 根据属性搜索
  export function getLibsdbSearchByAttrs(pid, status, type, name, page, size) {
    let reqData = {
      ...new Pagination(page, size),
      pid: pid,
      project_id: pid,
      status: status, // 文件当前状态
      answer_content: name // 属性
    }
    return request({
      url: `/v1/api/safe/annotate/validate/tags/libsdb/answer/content/search`,
      method: 'post',
      data: reqData
    })
  }







// WEBPACK FOOTER //
// ./src/api/DataNotes.js